import { Powertrain } from "./../models/powertrain";
import { MessageService } from "./../services/message.service";
import { Message } from "./../common/message";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";
import { PowertrainService } from "../services/powertrain.service";

let ELEMENT_DATA = [];
@Component({
  selector: "app-powertrain",
  templateUrl: "./powertrain.component.html",
  styleUrls: ["./powertrain.component.scss"],
})
export class PowertrainComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = [
    "SN",
    "name",
    "code",
    "lastTripHours",
    "contract",
    "desc",
    "actions",
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  resource: any;

  constructor(
    private dialog: MatDialog,
    private service: PowertrainService,
    private formBuilder: FormBuilder,
    private msg: MessageService
  ) {}

  ngOnInit() {
    this.resource = new Powertrain();
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      code: ["", Validators.required],
      desc: ["", Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll().subscribe((result) => {
      ELEMENT_DATA = ELEMENT_DATA.concat(result);
      this.updateDataSource();
    });
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resource = new Powertrain();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave(name: HTMLDataElement, code: HTMLDataElement, desc: HTMLDataElement) {
    this.submitted = true;

    if (this.form.controls.name.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement(name, code, desc);
    } else {
      this.addElement(name, code, desc);
    }
  }

  resetForm(ret?: boolean) {
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement(name, code, desc) {
    this.resource.setName(name.value);
    this.resource.setCode(code.value);
    this.resource.setDesc(desc.value);

    this.service.create(this.resource).subscribe(
      (result) => {
        this.msg.alert(Message.SAVE);
        ELEMENT_DATA.push(result);
        this.updateDataSource();
        this.resource = new Powertrain();
        this.resetForm();
      },
      (err: any) => {
        if (err.status == 422) {
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      }
    );
  }

  updateElement(name, code, desc) {
    this.resource.setName(name.value);
    this.resource.setCode(code.value);
    this.resource.setDesc(desc.value);

    this.service.update(this.resource).subscribe(
      (result) => {
        this.msg.alert(Message.UPDATE);
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id) {
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        });

        this.updateDataSource();
        this.resource = new Powertrain();
        this.resetForm(true);
      },
      (err: any) => {
        if (err.status == 422) {
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      }
    );
  }

  editElement(ele) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource = ele;
    this.resource = new Powertrain();

    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setCode(ele.code);
    this.resource.setDesc(ele.desc);

    this.form.controls.name.setValue(ele.name);
    this.form.controls.code.setValue(ele.code);
    this.form.controls.desc.setValue(ele.desc);
  }

  deleteElement(ele) {
    this.dialog
      .open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result === "true") {
          this.service.delete(ele.id).subscribe((result) => {
            this.msg.alert(Message.DELETE);
            let index = ELEMENT_DATA.indexOf(ele);
            ELEMENT_DATA.splice(index, 1);
            this.updateDataSource();
          });
        } else {
          return;
        }
      });
  }
}
